import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ApiKeysPage = lazy(() => import('./pages/ApiKeysPage'));

export const ApiKeysRoutes: RouteObject = {
  path: 'api-keys',
  children: [
    { path: '', element: <ApiKeysPage />, handle: { crumb: 'API Keys & Webhooks' } },
  ],
};
